<div class="container pt-100">
    <!-- Table -->
    <div class="row">
      <div class="col">
        <div class="card shadow bg-white">
          <div class="card-header border-0 bg-white">
              <div class="row">
                  <div class="col-9">
                      <h4 class="mb-0">Define Vision of the Organization</h4>
                  </div>
                  <div class="col-3">
                      <a
                        class="btn btn-gradient-success btn-rounded  btn-sm btn-fw text-white float-right"                      
                      >
                        <i class="fa fa-plus mr-1"></i> Add Vision
                      </a>
                  </div>
              </div>          
          </div>
          <div class="table-responsive">
            <table class="table align-items-center table-bordered text-center">
              <thead>
                <tr>
                  <th scope="col">Vision Name</th>
                  <th scope="col">Quantify</th>
                  <th scope="col">Remarks</th>
                  <th scope="col" class="text-center">Actions</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <th scope="row">
                    <div class="media align-items-center">                    
                      <div class="media-body">
                        <span class="mb-0 text-sm">Vision1</span>
                      </div>
                    </div>
                  </th>
                  <td>Achieve 50 million </td>
                  <td>
                    <i class="fa fa-circle text-primary mr-4"></i> 
                    no remarks
                  </td>
                  <td>
                    <div>
                      <a
                        class="btn btn-gradient-warning btn-rounded  btn-sm text-white"
                        placement="top"
                        ngbTooltip="Edit"
                      >
                        <i class="fa fa-edit"></i>
                      </a>
                      <a
                        class="btn btn-gradient-danger btn-rounded  btn-sm text-white"
                        placement="top"
                        ngbTooltip="Delete"
                      >
                        <i class="fa fa-trash"></i>
                      </a>
                    </div>
                  </td>
                </tr>
                <tr>
                  <th scope="row">
                    <div class="media align-items-center">                    
                      <div class="media-body">
                        <span class="mb-0 text-sm">Vision2</span>
                      </div>
                    </div>
                  </th>
                  <td>Achieve 60 million</td>
                  <td>
                    <i class="fa fa-circle text-success mr-4"></i> 
                    no remarks
                  </td>
                  <td>
                    <div>
                      <a
                      class="btn btn-gradient-warning btn-rounded  btn-sm text-white"
                      placement="top"
                      ngbTooltip="Edit"
                    >
                      <i class="fa fa-edit"></i>
                    </a>
                    <a
                      class="btn btn-gradient-danger btn-rounded  btn-sm text-white"
                      placement="top"
                      ngbTooltip="Delete"
                    >
                      <i class="fa fa-trash"></i>
                    </a>
                    </div>
                  </td>
                </tr>
                <tr>
                  <th scope="row">
                    <div class="media align-items-center">                    
                      <div class="media-body">
                        <span class="mb-0 text-sm">Vision3</span>
                      </div>
                    </div>
                  </th>
                  <td>Achieve 70 million</td>
                  <td>
                    <i class="fa fa-circle text-danger mr-4"></i> 
                    no remarks
                  </td>
                  <td>
                    <div>
                      <a
                      class="btn btn-gradient-warning btn-rounded  btn-sm text-white"
                      placement="top"
                      ngbTooltip="Edit"
                    >
                      <i class="fa fa-edit"></i>
                    </a>
                    <a
                      class="btn btn-gradient-danger btn-rounded  btn-sm text-white"
                      placement="top"
                      ngbTooltip="Delete"
                    >
                      <i class="fa fa-trash"></i>
                    </a>
                    </div>
                  </td>
                </tr>
                <tr>
                  <th scope="row">
                    <div class="media align-items-center">                    
                      <div class="media-body">
                        <span class="mb-0 text-sm">Vision4</span>
                      </div>
                    </div>
                  </th>
                  <td>Achieve 80 million</td>
                  <td>
                    <i class="fa fa-circle text-warning mr-4"></i> 
                    no remarks
                  </td>
                  <td>
                    <div>
                      <a
                      class="btn btn-gradient-warning btn-rounded  btn-sm text-white"
                      placement="top"
                      ngbTooltip="Edit"
                    >
                      <i class="fa fa-edit"></i>
                    </a>
                    <a
                      class="btn btn-gradient-danger btn-rounded  btn-sm text-white"
                      placement="top"
                      ngbTooltip="Delete"
                    >
                      <i class="fa fa-trash"></i>
                    </a>
                    </div>
                  </td>
                </tr>
                <tr>
                  <th scope="row">
                    <div class="media align-items-center">                    
                      <div class="media-body">
                        <span class="mb-0 text-sm">Vision5</span>
                      </div>
                    </div>
                  </th>
                  <td>Achieve 90 million</td>
                  <td>
                    <i class="fa fa-circle text-secondary mr-4"></i> 
                    no remarks
                  </td>
  
                  <td>
                    <div>
                      <a
                      class="btn btn-gradient-warning btn-rounded  btn-sm text-white"
                      placement="top"
                      ngbTooltip="Edit"
                    >
                      <i class="fa fa-edit"></i>
                    </a>
                    <a
                      class="btn btn-gradient-danger btn-rounded  btn-sm text-white"
                      placement="top"
                      ngbTooltip="Delete"
                    >
                      <i class="fa fa-trash"></i>
                    </a>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>          
        </div>
      </div>
    </div>
  </div>
  
  
